var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qr-code-container j-qr-code-container"},[_c('p',{staticClass:"txt-tips",domProps:{"innerHTML":_vm._s(_vm.qrCodeTipe)}}),_vm._v(" "),_c('div',{staticClass:"qr-code-wrapper j-load-qr-code",class:{
      qrcodeWrapperLogined: _vm.user.id && !_vm.showQrCode,
      qrCodeWrapperLoaded: _vm.user.id && _vm.showQrCode && !_vm.timeout,
      qrCodeWrapper: !_vm.user.id
    },on:{"click":_vm.loadQRCode}},[(_vm.user.id && !_vm.showQrCode)?_c('div',{staticClass:"line"}):_vm._e(),_vm._v(" "),(_vm.user.id && !_vm.showQrCode)?_c('div',{staticClass:"img-tips",class:{
        load: _vm.beforeLaodQrCode && !_vm.timeout,
        refresh: !_vm.beforeLaodQrCode && _vm.timeout
      }}):_vm._e(),_vm._v(" "),(!_vm.user.id || (_vm.showQrCode && !_vm.timeout))?_c('img',{staticClass:"qr-code-img",attrs:{"src":_vm.qrCodeSRc}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c9e9a71","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/QrCode.vue
// module id = null
// module chunks = 